
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/result",
      function () {
        return require("private-next-pages/result/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/result"])
      });
    }
  